module.exports = __webpack_public_path__ + "static/TT1394_TW-MARK-M01_r1-clean-40caff6f878c2192cc03adc2faeb2ca3.png";